// @ts-check
import { computed, onDeactivated, readonly, ref } from 'vue';

import useBulkSendRoutes from '@/composables/bulkSend/routes';

export default function useBulkSendUhoh() {
  // templates outdated
  const { reimportRoutes } = useBulkSendRoutes();

  /** @type {import('vue').Ref<string>} uhoh */
  const uhoh = ref();

  function closeUhoh() {
    uhoh.value = undefined;
  }

  const uhohRoute = computed(() => reimportRoutes[uhoh.value]);

  function onError(error) {
    if (error.response.status === 400 && error.response.data.bulk_send_import) {
      uhoh.value = error.response.data.bulk_send_import;

      return;
    }

    throw error;
  }

  // if the route changes without dismissing the modal close it
  onDeactivated(closeUhoh);

  return {
    uhoh: readonly(uhoh),
    closeUhoh,
    uhohRoute,
    onError,
  };
}
